<template>
  <v-card
    class="product-slider-card"
    elevation="0"
    flat
    :to="link"
    @click.prevent="handleLink"
  >
    <v-img
      :src="img"
      alt="Immagine categoria"
      class="product-slider-card-image"
    />
    <v-card-text v-if="text" v-html="text"> </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions v-if="link">
      <v-btn :to="link" color="secondary" block depressed
        >{{ linkLabel }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss">
.product-slider-card {
  display: flex;
  flex-direction: column;
  border-radius: 12px 12px 12px 0px !important;
}
</style>
<script>
export default {
  name: "ProductSliderCard",
  props: {
    img: { type: String, required: true },
    text: { type: String, required: true },
    link: { type: [String, Object], required: false },
    linkLabel: { type: String, required: false, default: "Mostra tutti" }
  }
};
</script>
